import React from 'react';
import NavbarComponent from '../pages/Navbar';
import Footer from '../Footer';
import CommitmentSection from "../CommitmentSection";
import HangerBanner from './HangerBanner';
import HangerInfo from './HangerInfo';

const HangerDetails = () => {
  return (
    <>
      <NavbarComponent />
      <HangerBanner />
      <CommitmentSection />
      <HangerInfo />
      <Footer />
    </>
  );
};

export default HangerDetails;